export default __webpack_public_path__ + "static/media/Marianna Muliro.8035ec02.JPG";